// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24nTM","content":"styles_content__O-0Ij"};